import {useLocation, useNavigate} from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import {useState} from "react";
import AdminNav from "../../Components/AdminNav/AdminNav";
import { IMAGE_URL} from "../../path";
import {updatePartnershipImages} from "../../actions/BusinessPages";

function EditPartnershipImage() {
    const location = useLocation();
    const user = location.state?.user;
    const image = location.state?.image;
    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    const [imageError, setImageError] = useState<string>("");

    const [imageFileDesktop, setImageFileDesktop] = useState<File | null>(null);
    const [previewUrlDesktop, setPreviewUrlDesktop] = useState<string>(`${IMAGE_URL}${image.image}`);

    const [imageFileMobile, setImageFileMobile] = useState<File | null>(null);
    const [previewUrlMobile, setPreviewUrlMobile] = useState<string>(`${IMAGE_URL}${image.mobile_image}`);

    const [isCollapsed, setIsCollapsed] = useState(true);

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>, type: "desktop" | "mobile") => {
        const file = e.target.files?.[0];
        if (file) {
            if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
                setImageError("Please upload a valid image file (jpg, jpeg, or png).");
                if (type === "desktop") setImageFileDesktop(null);
                else setImageFileMobile(null);
                return;
            }

            setImageError("");
            const objectUrl = URL.createObjectURL(file);

            if (type === "desktop") {
                setImageFileDesktop(file);
                setPreviewUrlDesktop(objectUrl);
            } else {
                setImageFileMobile(file);
                setPreviewUrlMobile(objectUrl);
            }
        }
    };

    const removeSelectedImage = (type: "desktop" | "mobile") => {
        if (type === "desktop") {
            setImageFileDesktop(null);
            setPreviewUrlDesktop(`${IMAGE_URL}${image.image}`);
        } else {
            setImageFileMobile(null);
            setPreviewUrlMobile(`${IMAGE_URL}${image.mobile_image}`);
        }
    };
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const response = await updatePartnershipImages(
                image.id, // you'll need to define this state/prop
                imageFileDesktop ? imageFileDesktop : undefined, // you'll need to define this state
                imageFileMobile ? imageFileMobile : undefined // you'll need to define this state
            );

            if (response.status === 201) {
                alert("Partnership images updated successfully!");
                navigate('/dashboard/business/partnership', {
                    state: { user }
                });
            } else {
                console.error('Error updating partnership images:', response.data);
                alert("Failed to update partnership images. Please try again.");
            }

            // You might want to show a success message or redirect
        } catch (error) {
            // Handle error
            console.error('Error updating partnership images:', error);
            // You might want to show an error message to the user
        }
    };
    return <div>
        <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user}/>
        <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user}/>

        <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
            <div className="main-admin-page-inner">
                <h2>Edit Partnership Image</h2>

                <form onSubmit={handleSubmit}>
                    {/* Desktop Image Upload */}
                    <div className="content-form-field">
                        <label><strong>Desktop Image</strong></label><br />
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => handleImageChange(e, "desktop")}
                            style={{ margin: '10px 0' }}
                        />
                        {imageError && <div style={{ color: 'red' }}>{imageError}</div>}
                        {previewUrlDesktop && (
                            <div style={{ marginTop: '10px' }}>
                                <img
                                    src={previewUrlDesktop}
                                    alt="Desktop Preview"
                                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                                />
                                <br />
                                <button
                                    type="button"
                                    onClick={() => removeSelectedImage("desktop")}
                                    style={{ marginTop: '5px' }}
                                >
                                    Remove Desktop Image
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Mobile Image Upload */}
                    <div className="content-form-field" style={{ marginTop: '20px' }}>
                        <label><strong>Mobile Image</strong></label><br />
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => handleImageChange(e, "mobile")}
                            style={{ margin: '10px 0' }}
                        />
                        {imageError && <div style={{ color: 'red' }}>{imageError}</div>}
                        {previewUrlMobile && (
                            <div style={{ marginTop: '10px' }}>
                                <img
                                    src={previewUrlMobile}
                                    alt="Mobile Preview"
                                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                                />
                                <br />
                                <button
                                    type="button"
                                    onClick={() => removeSelectedImage("mobile")}
                                    style={{ marginTop: '5px' }}
                                >
                                    Remove Mobile Image
                                </button>
                            </div>
                        )}
                    </div>
                    <button type="submit" className="btn-submit">Save Changes</button>
                </form>
            </div>
        </div>
    </div>;
}

export default EditPartnershipImage;
